<template>
  <div class="recharge-page full-height">
    <full-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: 'orderList' }">{{ $t('common.home') }}</el-breadcrumb-item>
          <!-- <el-breadcrumb-item :to="{ path: '/RechargeList' }">充值记录</el-breadcrumb-item> -->
          <el-breadcrumb-item>{{ $t('recharge.recharge') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="full">
        <div class="recharge-content">
          <div class="notice">
            <div>
              <div>{{ $t('recharge.rechargeTip') }}</div>
              <div>{{ $t('recharge.rechargeTip2') }}</div>
            </div>
            <el-button class="form-btn btn-blue" @click="toRechargeList" style="margin-left: 20px">
              {{ $t('recharge.viewRechargeLog') }}</el-button>
          </div>
          <div class="top">
            <div class="tag-item">
              <!--注意，修改了以下银行信息时需要将表 oytqc_recharge_notice 截断-->
              <!--注意，修改了以下银行信息时需要将表 oytqc_recharge_notice 截断-->
              <!--注意，修改了以下银行信息时需要将表 oytqc_recharge_notice 截断-->
              <div class="content account-content5">振込先詳細：</div>
              <div class="content account-content4">銀行名：楽天銀行</div>
              <div class="content account-content4">支店名：第三営業支店(253)</div>
              <div class="content account-content4">口座種別：普通</div>
              <div class="content account-content4">口座番号：7485640</div>
              <div class="content account-content4">名義：アリパートナーズ（カ</div>
            </div>
          </div>
          <div class="bottom">
            <el-form :model="chargeForm" :rules="chargeFormRules" ref="chargeForm" label-width="130px" class="charge-form">
              <el-form-item :label="$t('recharge.payDate')" prop="payTime13">
                <el-date-picker v-model="chargeForm.payTime13" type="date" value-format="timestamp"
                  :placeholder="$t('common.pleaseSelect')" clearable @change="payTimeChange"></el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('recharge.rechargeType')" prop="rechargeType">
                <el-select v-model="chargeForm.rechargeType" @change="handleChange" :placeholder="$t('common.pleaseSelect')">
                  <el-option v-for="(item, index) in rechargeTypeOptions" :key="index" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="chargeForm.rechargeType == '0' || chargeForm.rechargeType == '1'" prop="orderNum"
                :label="$t('recharge.tradeOrderNo')">
                <el-input v-model="chargeForm.orderNum" clearable></el-input>
              </el-form-item>
              <el-form-item v-if="chargeForm.rechargeType == '2'" :label="$t('recharge.payAccount')" prop="bankNo">
                <el-input v-model="chargeForm.bankNo" clearable></el-input>
              </el-form-item>
              <el-form-item :label="$t('recharge.payUser')" prop="drawee">
                <div style="display:flex">
                  <el-input style="width:514px" v-model="chargeForm.drawee" clearable></el-input>
                  <el-checkbox style="margin-left:20px" v-model="chargeForm.paymentInfoFlag">{{$t('recharge.tips')}}</el-checkbox>
                </div>
              </el-form-item>

              <el-form-item :label="$t('recharge.amountJPY')" prop="moneyJpy">
                <el-input
                    v-model="displayMoneyJpy"
                    type="tel"
                    :maxlength="10"
                    @input="onJpyInput"
                    @focus="onJpyFocus"
                    @blur="onJpyBlur"
                    @mousewheel.native.prevent
                >
                  <span slot="suffix">{{ $t('recharge.JPY') }}</span>
                </el-input>
              </el-form-item>
              <el-form-item :label="$t('recharge.amountCNY')" prop="money">
                <el-input
                    v-model="displayMoneyCny"
                    readonly
                >
                  <span slot="suffix">{{ $t('recharge.CNY') }}</span>
                </el-input>
              </el-form-item>

              <el-row>
                <el-col :span="12">
                  <el-form-item :label="$t('recharge.verificationCode')" prop="verifycode">
                    <el-input v-model="chargeForm.verifycode" :placeholder="$t('common.pleaseInput')" class="identifyinput">
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="identifybox">
                  <div @click="refreshCode" class="overflow">
                    <div class="float" style="margin-left: 10px">
                      <s-identify :identifyCode="identifyCode"></s-identify>
                    </div>
                    <div class="float textbtn" @click="refreshCode">{{ $t('recharge.verificationCodeTip') }}</div>
                  </div>
                </el-col>
              </el-row>
              <el-form-item>
                <el-button class="form-btn btn-gray" @click="resetForm('chargeForm')">{{ $t('common.reset') }}</el-button>
                <el-button class="form-btn btn-blue" @click="submitForm('chargeForm')">{{ $t('common.submit') }}</el-button>
                <el-button class="form-btn btn-blue" @click="toRechargeList" style="margin-left: 20px">
                  {{ $t('recharge.viewRechargeLog') }}</el-button>
              </el-form-item>
            </el-form>
          </div>

          <!-- <div class="top-title"></div>
          <div class="user-num">
            <span>开通账号：</span>
            <span></span>
          </div>
          <div class="tab-container">
            <div @click="currentTab('1')" :class="currentTabFlag=='1'?'cur-tab tab-content':'tab-content'">
              <div class="tab-top">
                <span class="price">500</span>
                <span>元</span>
              </div>
              <div class="tab-bottom">
                标准价：500元
              </div>
            </div>
            <div :class="currentTabFlag=='2'?'cur-tab tab-content':'tab-content'" @click="currentTab('2')">
              <div class="tab-top">
                <span class="price">5000</span>
                <span>元</span>
              </div>
              <div class="tab-bottom">
                标准价：5000元
              </div>
            </div>
            <div :class="currentTabFlag=='3'?'cur-tab tab-content':'tab-content'" @click="currentTab('3')">
              <div class="tab-top">
                <span class="price">10000</span>
                <span>元</span>
              </div>
              <div class="tab-bottom">
                标准价：10000元
              </div>
            </div>
            <div :class="currentTabFlag=='4'?'cur-tab tab-content eidt-tab-content':'tab-content eidt-tab-content'"  @click="currentTab('4')">
              <div class="tab-top">
                <el-row>
                  <el-col :span="20">
                    <el-input placeholder="请输入金额" type="number" @mousewheel.native.prevent size="small" v-model="editPrice" @input="editPriceChange" :min='0' :precision='2' :width='200' @change='getQRCode(editPrice)'></el-input>
                  </el-col>
                  <el-col :span="4">
                    <span>元</span>
                  </el-col>
                </el-row>
              </div>
              <div class="tab-bottom">
                标准价：{{editPrice}}元
              </div>
            </div>
          </div>
          <div class="charge-way-container">
             <div class="charge-price">
               <span>应付金额：</span>
               <span class="price">{{actPrice?Number(actPrice).toFixed(2):''}}</span>
               <span>元</span>
              </div>
              <div class="charge-way" v-loading="loading">
                <div class="zfb">
                  <div class="code-con">
                    <div id="qrcode" ref="qrcodeImg"></div>
                  </div>
                  <div class="name-con"><img src="../../assets/images/recharge/icon_zfb.png" alt=""></div>
                  <div class="reflesh" @click="getQRCode(actPrice)">刷新二维码</div>
                </div>
              </div>
          </div> -->
        </div>
      </div>
    </full-con>
    <el-dialog :visible.sync="msgShow" :close-on-click-modal="false" center>
      <div class="msgBox">
        <div class="msgBox_top">
          <img src="../../assets/images/recharge/icon_success.png" alt="" />
          <span>{{ $t('recharge.submitSuccessTip') }}</span>
          <!-- <img src="../../assets/images/recharge/icon_defeated.png" alt="" v-if='!isPay'>
          <span v-if='!isPay'>充值失败 请确认您已支付</span> -->
        </div>
        <div class="msgBox_content">
          <p>
            {{ $t('recharge.rechargeAmount') }}：
            <span>{{ '￥' + formatThousands(actPrice) }}</span>
          </p>
          <p>
            {{ $t('recharge.submitTime') }}：
            <span>{{ submitTime | dateFormatToSecond }}</span>
          </p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="closeMsg" v-if='isPay'>返回充值中心</el-button> -->
        <el-button type="primary" @click="toRechargeList">{{ $t('recharge.viewRechargeLog') }}</el-button>
        <!-- <div v-if='!isPay'>如有疑问请联系管理员，<span class="countDownTime">{{countDownTime}}</span>秒后返回充值界面</div> -->
      </span>
    </el-dialog>
  </div>
</template>
<script>
import fullCon from '../../views/FullContainer';
import QRCode from 'qrcodejs2';
//import { delete } from 'vue/types/umd';
//import axios from "axios";
import SIdentify from './identify';
import t from "@/i18n/zh-CN";

export default {
  components: { fullCon, QRCode, SIdentify },
  data () {
    /* 自定义验证码规则 */
    const validateVerifycode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('common.pleaseInput')));
      } else if (value !== this.identifyCode) {
        callback(new Error(this.$t('recharge.verificationCodeError')));
      } else {
        callback();
      }
    };
    return {
      exchangeRate: 0.0502, //日元汇率
      submitTime: '',
      loading: false,
      msgShow: false, //是否支付成功弹窗显示
      isPay: false, //是否支付成功
      editPrice: null,
      currentTabFlag: '1',
      actPrice: 0,
      zfbUrl: '',
      timerTaks: null, //定时监听二维码是否支付成功
      timer: null, //失败倒计时
      countDownTime: 5,
      payTime: '', //充值时间
      exchangeRateInfo: {
        exchangeRate: 0
      },
      rechargeTypeOptions: [
        {
          name: this.$t('recharge.bankTransfer'),
          value: '2'
        }
        // {
        //   name: this.$t('recharge.alipay'),
        //   value: '1',
        // },
        // {
        //   name: this.$t('recharge.wechat'),
        //   value: '0',
        // },
      ],
      chargeForm: {
        payTime13: '',
        payTime: '',
        rechargeType: '2', //20220818 默认银行转账
        orderNum: '',
        bankNo: '',
        drawee: '',
        money: '',
        moneyJpy: '',
        exchangeRate: '',
        verifycode: '',
        paymentInfoFlag: true
      },
      chargeFormRules: {
        payTime13: [{ required: true, message: this.$t('common.pleaseSelect'), trigger: 'blur' }],
        rechargeType: [{ required: true, message: this.$t('common.pleaseSelect'), trigger: 'blur' }],
        orderNum: [{ required: true, message: this.$t('common.pleaseInput'), trigger: 'blur' }],
        bankNo: [{ required: true, message: this.$t('common.pleaseInput'), trigger: 'blur' }],
        drawee: [{ required: true, message: this.$t('common.pleaseInput'), trigger: 'blur' }],
        moneyJpy: [{ required: true, message: this.$t('common.pleaseInput'), trigger: 'blur' }],
        // money: [{required: true, message: this.$t('common.pleaseInput'), trigger: 'blur'}],
        verifycode: [{ required: true, message: this.$t('common.pleaseInput'), trigger: 'blur' }, { validator: validateVerifycode }]
      },
      identifyCodes: '1234567890abcdefghijklm',
      identifyCode: '',
      displayMoneyJpy: '',
      displayMoneyCny: '',
    };
  },
  methods: {
    /* ================= 金额千分位处理 ================= */

    // 输入中（日元）
    onJpyInput(val) {
      // 只允许数字
      const clean = val.replace(/[^\d]/g, '')
      this.displayMoneyJpy = clean
      this.chargeForm.moneyJpy = clean ? Number(clean) : ''
      this.updateCny()
    },

    // 聚焦：去掉千分位
    onJpyFocus() {
      if (this.chargeForm.moneyJpy !== '') {
        this.displayMoneyJpy = String(this.chargeForm.moneyJpy)
      }
    },

    // 失焦：加千分位
    onJpyBlur() {
      if (this.chargeForm.moneyJpy === '') {
        this.displayMoneyJpy = ''
        return
      }
      this.displayMoneyJpy = this.formatThousands(this.chargeForm.moneyJpy)
    },

    // 重新计算人民币
    updateCny() {
      const value = Number(this.chargeForm.moneyJpy)
      const rate = Number(this.exchangeRateInfo.exchangeRate)
      if (!value || !rate) {
        this.chargeForm.money = ''
        this.displayMoneyCny = ''
        return
      }
      const money = Math.floor((value / rate) * 100) / 100
      this.chargeForm.money = money
      this.displayMoneyCny = this.formatThousands(money)
    },

    // 千分位工具
    formatThousands(num) {
      return Number(num).toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      })
    },

    /* ================= 金额千分位处理 ================= */
    async queryJpyExchangeRate () {
      //获取
      const { data: res } = await this.$http.get('exchangeRate/queryJPYExchangeRate', {
        params: {}
      });
      this.exchangeRateInfo = res.data;
      this.chargeForm.exchangeRate = this.exchangeRateInfo.exchangeRate;
    },
    //根据日元汇率计算人民币
    getCNY () {
      let value = this.chargeForm.moneyJpy;
      let rate = this.exchangeRateInfo.exchangeRate;
      let money = Math.floor(parseFloat((value / rate) * 100)) / 100;
      this.chargeForm.money = money;
      return money;
    },
    payTimeChange () {
      this.chargeForm.payTime = this.chargeForm.payTime13 / 1000;
    },
    handleChange () {

    },
    getPaymentInfo () {
      this.$http
        .get('payRecord/queryPaymentInfo')
        .then((res) => {
          if (res.data.code == 200) {
            this.chargeForm.bankNo = res.data.data.bankNo
            this.chargeForm.drawee = res.data.data.drawee
            this.chargeForm.paymentInfoFlag = res.data.data.paymentInfoFlag == 1 ? true : false
          }
        })
        .catch((res) => {
          console.log(res)
        });
    },
    submitForm (name) {
      var _this = this;
      console.log(this.chargeForm)
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.msgShow = true;
          if (this.chargeForm.paymentInfoFlag) {
            this.chargeForm.paymentInfoFlag = 1
          } else {
            this.chargeForm.paymentInfoFlag = 0
          }
          this.$http
            .post('payRecord/saveAction', this.chargeForm)
            .then((res) => {
              if (res.data.code == 200) {
                _this.actPrice = _this.chargeForm.money;
                _this.submitTime = res.data.data.createTime;
                // _this.$message.success(res.data.message);
                _this.msgShow = true;
              } else {
                _this.$message.error(res.data.message);
              }
              _this.refreshCode();
            })
            .catch((res) => {
              // console.log(res);
            });
        } else {
          return false;
        }
      });
    },
    resetForm (name) {
      this.$refs[name].resetFields();
    },
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    // 切换验证码
    refreshCode () {
      this.identifyCode = '';
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode (o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    },
    currentTab (curTab) {
      this.currentTabFlag = curTab;
      if (curTab == 1) {
        this.actPrice = 500.0;
        this.getQRCode(500);
      } else if (curTab == 2) {
        this.actPrice = 5000.0;
        this.getQRCode(5000);
      } else if (curTab == 3) {
        this.actPrice = 10000.0;
        this.getQRCode(10000);
      } else if (curTab == 4 && (this.editPrice == null || this.editPrice == '')) {
        this.actPrice = 0;
        this.getQRCode(0);
        this.$refs.qrcodeImg.innerHTML = '';
      }
    },
    editPriceChange (e) {
      let that = this;
      that.actPrice = e;
    },
    //获取二维码地址
    getQRCode (e) {
      let that = this;
      clearInterval(that.timerTask); //清除timerTask定时器
      if (e == 0) {
        return false;
      }
      let formdata = new FormData();
      formdata.append('money', e);
      that.loading = true;
      that.$http.post('alipay/alipay.do', formdata).then((res) => {
        if (res.status == 200) {
          // // QRCode 为后端接口返回的图片数据流
          // let QRCodes = res.data
          // const blob = new Blob([QRCodes])
          const orderNo = res.data.out_trade_no;
          const url = res.data.qr_code;
          //console.log(url,'================================');
          //delete qrcode
          //console.log(that.$refs.qrcodeImg)
          //document.getElementById("qrcode").innerHTML = "";
          that.$refs.qrcodeImg.innerHTML = '';
          let qrcode = new QRCode('qrcode', {
            width: 100,
            height: 100,
            text: url
          });
          that.loading = false;
          that.countDownTime = 5;
          //定时请求检测是否支付了-隔1秒请求一次
          that.timerTask = setInterval(() => {
            that.getCheck(orderNo);
          }, 1000);
        }
      });
    },
    //检测是否扫描二维码成功
    getCheck (e) {
      let that = this;
      let formdata = new FormData();
      formdata.append('orderNum', e);
      that.$http.post('alipay/aliget', formdata).then((res) => {
        //console.log(res,'=======================')
        if (res.status == 200) {
          if (res.data.type == 1) {
            clearInterval(that.timerTask); //清除timerTask定时器
            setTimeout(() => {
              //显示支付成功弹窗
              that.payTime = res.data.time;
              that.msgShow = true;
              that.isPay = true;
            }, 500);
          } else if (res.data.type == 2) {
            setTimeout(() => {
              //显示支付失败弹窗
              that.payTime = res.data.time;
              that.msgShow = true;
              that.isPay = false;
              that.countDown();
            }, 500);
            clearInterval(that.timerTask); //清除timerTask定时器
          }
        }
      });
    },
    //倒计时
    countDown () {
      let that = this;
      clearInterval(that.timer);
      if (that.countDownTime > 0) {
        that.timer = setInterval(() => {
          that.countDownTime = that.countDownTime - 1;
          that.countDown();
        }, 1000);
      } else {
        that.msgShow = false;
        that.getQRCode(that.actPrice);
      }
    },
    //返回充值记录
    toRechargeList () {
      this.$router.push({
        name: 'RechargeList'
      });
    },
    //返回用户中心
    closeMsg () {
      let that = this;
      that.msgShow = false;
    },
    noticeIsRead(){
      this.$http
        .get('payRecord/noticeIsRead')
        .then((res) => {
          if (res.data.code == 200  && res.data?.data === 0) {
            this.$confirm( this.$t('recharge.rechargeConfirmText'),'注意⚠️', {
              confirmButtonText: this.$t('recharge.rechargeConfirmButtonText'),
              confirmButtonClass: "form-btn btn-blue",
              cancelButtonText: this.$t('recharge.rechargeCancelButtonText'),
              cancelButtonClass: "form-btn btn-gray",
              closeOnClickModal:false,
              distinguishCancelAndClose: true,
            }).then(async () => {}).catch((action) => {
              if (action === 'cancel'){
                this.noticeRead()
              }
            });
          }
        })
        .catch((res) => {
          console.log(res)
        });
    },
    noticeRead(){
      this.$http
          .get('payRecord/noticeRead')
          .then((res) => {
              console.log(res)
          })
          .catch((res) => {
            console.log(res)
          });
    }
  },
  async created () {
    this.noticeIsRead();
    await this.queryJpyExchangeRate();
    if (this.$route.query.num) {
      let rate = this.exchangeRateInfo.exchangeRate;
      this.chargeForm.moneyJpy = this._.ceil(this._.multiply(Number(this.$route.query.num), rate), 2)
    }
    this.identifyCode = '';
    // this.dateFormatToDay=new Date()
    // this.dateFormatToDay=this.dateFormatToDay.getFullYear() + "-" + (this.dateFormatToDay.getMonth() + 1) + "-" + this.dateFormatToDay.getDate();
    this.makeCode(this.identifyCodes, 4);
    // disableBrowserBack();
    history.pushState(null, null, document.URL);
    if (window.history && window.history.pushState) {
      // window.on('popstate', function (){
      //   window.history.pushState('forward', null, '');
      //   window.history.forward(1);
      // });
      window.history.pushState('forward', null, ''); //在IE中必须得有这两行
      window.history.forward(1);
    }
    this.getPaymentInfo()

  },
  beforeDestroy () {
    //页面销毁前，清除定时器
    clearInterval(this.timerTask);
    clearInterval(this.timer);
  },
  watch: {
    // actPrice(newVal,olaval){
    //   setTimeout(()=>{
    //     this.getQRCode(newVal)
    //   },2500)
    // }
  }
};
</script>
<style scoped lang="less">
.tab-top /deep/ input::placeholder {
  color: #d2a676;
}

.tab-top /deep/ input::-webkit-outer-spin-button,
.tab-top /deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

.tab-top input[type="number"] {
  -moz-appearance: textfield !important;
}

.recharge-content {
  width: 920px;
  margin: 0 auto;

  .notice {
    padding: 15px 10px;
    background: #f5f6f8;
    border-radius: 5px;
    //margin-bottom: 15px;
    margin-top: 20px;
    margin-left: 25px;
    display: flex;
    justify-content: space-between;
  }

  .top {
    overflow: hidden;
  }

  .bottom {
    width: 90%;
    margin-top: -40px;
  }
}

.textbtn {
  color: #268df5;
  display: inline-block;
  height: 38px;
  line-height: 38px;
  margin-left: 10px;
}

/* .top-title{
  text-align: center;
  height: 70px;
  margin-top: 30px;
  margin-bottom: 20px;
  background: url('../../assets/images/recharge/banner.png')  0 0 no-repeat ;
  background-size: 100%;
} */

/* tab */
/* .tab-container{
  margin-top: 20px;
  overflow: hidden;
}
.tab-content{
  width: 200px;
  height: 115px;
  float: left;
  margin-right: 35px;
  border: 1px solid #9DA4C3;
  border-radius: 5px;
  position: relative;
}
.tab-content:hover{
  cursor: pointer;
}
.eidt-tab-content{
  margin-right: 0;
}
.tab-top{
  text-align: center;
  height: 73px;
  line-height: 73px;
  padding-left: 10px;
}
.tab-top .price{
  text-align: center;
  font-size: 48px;
  color: #D2A676;
  margin:0 10px;
}
.price{
  text-align: center;
  font-size: 24px;
  color: #D2A676;
  margin:0 10px;
}
.tab-bottom{
  text-align: center;
  height: 40px;
  line-height: 40px;
  background:#9DA4C3;
}

.recharge-page .cur-tab{
   border: 1px solid #D2A676;
   background:url('../../assets/images/recharge/duihao.png') no-repeat ;
   background-position:102% -4%;
   background-size:55px 46px;
   overflow: hidden;
}
.recharge-page .cur-tab .tab-bottom{
  background:#D2A676;
}

.charge-way-container{
  width: 920px;
  height: auto;
  padding: 20px;
  margin: 30px auto 0 auto;
  border: 1px dotted #9DA4C3;
}
.charge-price{
  text-align: center;
}
.charge-way{
  overflow: hidden;
  margin-top: 20px;
}
.charge-way .wx,.charge-way .zfb{
  float: left;
  width: 160px;
  margin-left: 359px;
}
.code-con{
  width: 160px;
  height: 160px;
  border: 1px solid green;
  overflow: hidden;
  position: relative;
}
#qrcode{
  position: absolute;
  top:50%;
  left:50%;
  margin-left:-50px ;
  margin-top:-50px ;
}
.name-con,.reflesh{
  margin-top: 10px;
  text-align: center;
}
.reflesh{
  color: #1373FB;
}
.name-con{
  position: relative;
  width: 100%;
  height: 64px;
}
.name-con img{
  position: absolute;
  display: block;
  width: 114px;
  height: 30px;
  top:50%;
  left: 50%;
  margin-left:-57px ;
  margin-top:-15px ;
} */

.recharge-content {
  overflow: hidden;
}

.tag-item {
  float: left;
  width: 450px;
  height: 310px;
  // margin-right: 51px;
  margin-left: 126px;
  //background: #F5F6F8;
  border-radius: 10px;
  margin-bottom: 44px;
  //padding: 20px;
  overflow: hidden;
  margin-top: 6px;
  background-repeat: no-repeat; //不重复
  background-size: 100% 100%; // 满屏
  background-image: url("../../assets/images/recharge/bank_bg.png");
  .account-content1 {
    //width: 69px;
    height: 24px;
    font-size: 24px;
    //font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    line-height: 90px;
    margin-top: 45px;
    margin-left: 45px;
  }
  .account-content2 {
    //width: 318px;
    height: 25px;
    font-size: 30px;
    //font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    margin-top: 48px;
    margin-left: 45px;
  }
  .account-content3 {
    //width: 214px;
    height: 18px;
    font-size: 18px;
    //font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    margin-top: 44px;
    margin-left: 45px;
  }
  .account-content4 {
    height: 18px;
    font-size: 18px;
    font-weight: 400;
    color: #ffffff;
    margin-top: 24px;
    margin-left: 45px;
  }
  .account-content5 {
    height: 18px;
    // font-size: 18px;
    font-weight: 400;
    color: #ffffff;
    margin-top: 30px;
    margin-left: 45px;
  }
  img {
    width: 100px;
    height: 100px;
  }

  .account-content {
    margin-top: 5px;
    margin-bottom: 10px;
  }

  .code-title,
  .code-content {
    float: left;
  }

  .code-content {
    margin-left: 20px;
  }
}

.last-tag-item {
  margin-right: 0;
}

.el-dialog__wrapper /deep/ .el-dialog {
  width: 1200px !important;
  height: 480px;
  padding-top: 95px !important;
}
.msgBox {
  width: 80%;
  margin: 0 auto;
}
.msgBox .msgBox_top {
  display: flex;
  justify-content: center;
}

.msgBox .msgBox_top img {
  display: inline-block;
  width: 48px;
  height: 48px;
  margin-right: 22px;
}

.msgBox .msgBox_top span {
  display: inline-block;
  text-align: center;
  font-size: 24px;
  color: #3a4255;
  font-family: Microsoft YaHei;
  font-weight: 400;
}

.msgBox_content {
  margin-top: 47px;
  margin-bottom: 36px;
  width: 100%;
  height: 15px;
  text-align: center;
}

.msgBox_content p {
  display: inline-block;
  color: #9da4c3;
  font-size: 14px;
  margin-right: 20px;
}

.msgBox_content span {
  display: inline;
  color: #3a4255;
  font-size: 14px;
}

.dialog-footer /deep/ .countDownTime {
  display: inline-block;
  color: #2e85a1;
  margin-right: 2px;
}

.dialog-footer /deep/ .el-button--default {
  width: 197px;
  height: 42px;
  border: 1px solid #2e85a1;
  border-radius: 4px;
}

.dialog-footer /deep/ .el-button--primary {
  width: 197px;
  height: 42px;
  border: 1px solid #2e85a1;
  background: #2e85a1;
  border-radius: 4px;
  color: #fff;
  margin-left: 46px;
}
</style>
